import CreateFundRequestWizardPage from "./CreateFundRequestWizardPage";

export default CreateFundRequestWizardPage;
